module.exports = __webpack_public_path__ + "img/POP-00011-1.8f208db4.png";